export const MerchantAccountStatus = {
    PENDING: 'Pending',
    PENDING_STRIPE: 'Pending Stripe',
    ACTIVE: 'Active',
    CLOSED: 'Closed',
    REJECTED: 'Rejected',
    NOT_SUBMITTED: 'Not Submitted',
    WATCHLIST: 'Watch List'
};
